import { Col, Row } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageMainTitle from '../../components/PageMainTitle';
import ContactUsTile from '../../components/ContactUsTile';
import QuestionsTile from './QuestionsTile';
import ResourcesLoader from '../../components/Resource/ResourcesLoader';
import FaqResource from './FaqResource';

export interface FaqPageProps {
  url: string;
}

const FaqPage: FC<FaqPageProps> = ({ url }) => {
  const { t } = useTranslation('Faq');
  return (
    <ResourcesLoader>
      <ResourcesLoader.Resources>
        <FaqResource url={url} autoRequest />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <PageMainTitle>
          {t('title')}
        </PageMainTitle>
        <Row gutter={16}>
          <Col xs={12} lg={8}>
            <QuestionsTile />
          </Col>
          <Col xs={12} lg={4}>
            <ContactUsTile />
          </Col>
        </Row>
      </ResourcesLoader.Content>
    </ResourcesLoader>
  );
};

export default FaqPage;
